import { Invoice } from '../../../types';

export function ElegantInvoicePreview({ invoice, company }: { invoice: Invoice, company: any, workspace: any }) {
  const gold = '#D4AF37';
  return (
    <div className="bg-gradient-to-br from-white to-yellow-50 mx-auto shadow-xl rounded-2xl p-12" style={{ width: '210mm', minHeight: '297mm', fontFamily: 'serif' }}>
      <div className="text-3xl italic font-bold mb-4 text-right" style={{ color: gold, fontFamily: 'cursive, serif' }}>{company.companyName}</div>
      <div className="text-xs text-gray-700 mb-2 text-right" style={{ whiteSpace: 'pre-line' }}>{company.address}</div>
      <div className="text-xs text-gray-700 mb-2 text-right">Phone: {company.phone}</div>
      <div className="text-xs text-gray-700 mb-2 text-right">{company.email}</div>
      <hr className="my-6 border-yellow-400" style={{ borderColor: gold }} />
      <div className="flex mb-4">
        <div className="flex-1 text-xs italic" style={{ color: gold }}>
          Invoice
        </div>
        <div className="flex-1 text-xs">
          <span className="font-bold text-lg" style={{ color: gold }}>{invoice.invoiceNumber}</span>
        </div>
        <div className="flex-1 text-xs text-right">
          Date: <span className="font-semibold">{new Date(invoice.issueDate).toLocaleDateString('en-GB')}</span><br />
          Due: <span className="font-semibold">{new Date(invoice.dueDate).toLocaleDateString('en-GB')}</span>
        </div>
      </div>
      <div className="font-bold text-xs mt-6 mb-1 italic" style={{ color: gold }}>Bill To</div>
      <div className="text-xs font-semibold">{invoice.client.name}</div>
      <div className="text-xs">{invoice.client.address}</div>
      <div className="text-xs">{invoice.client.phone}</div>
      <div className="text-xs">{invoice.client.email}</div>
      <hr className="my-6 border-yellow-400" style={{ borderColor: gold }} />
      <div className="grid grid-cols-12 gap-2 text-xs font-bold italic" style={{ color: gold }}>
        <div className="col-span-6">Description</div>
        <div className="col-span-2 text-center">Rate</div>
        <div className="col-span-2 text-center">Qty</div>
        <div className="col-span-2 text-right">Amount</div>
      </div>
      {invoice.items.map((item) => (
        <div key={item.id} className="grid grid-cols-12 gap-2 text-xs py-2">
          <div className="col-span-6">{item.description}</div>
          <div className="col-span-2 text-center">{item.rate}</div>
          <div className="col-span-2 text-center">{item.quantity}</div>
          <div className="col-span-2 text-right">{item.amount}</div>
        </div>
      ))}
      <hr className="my-6 border-yellow-400" style={{ borderColor: gold }} />
      <div className="flex justify-end">
        <div className="w-64 italic" style={{ color: gold }}>
          <div className="flex justify-between text-base font-bold"><span>Total:</span><span>{invoice.total}</span></div>
        </div>
      </div>
      <div className="text-xs text-gray-500 mt-12 italic text-right">Signature: ___________________________</div>
      {/* Signature */}
      {invoice.signature && (
        <div className="mt-10 text-center border-t pt-8" style={{ borderColor: gold, borderTopWidth: 2 }}>
          <div className="text-xs text-gray-500 mb-1">Authorized Signature</div>
          {invoice.signature.startsWith('http') ? (
            <img src={invoice.signature} alt="Signature" className="mx-auto h-14 object-contain" />
          ) : (
            <div className="italic text-xl font-signature text-gray-700" style={{ fontFamily: 'cursive, serif', color: gold }}>{invoice.signature}</div>
          )}
        </div>
      )}
    </div>
  );
} 